module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/travel-products/product-passenger-details/booking-total/booking-total.component.less
// module id = ./src/app/travel-products/product-passenger-details/booking-total/booking-total.component.less
// module chunks = main